import styled from 'styled-components';
import { unreadBar } from '@rsos/components/capstone/Chat/ChatHeader/ChatHeader.styles';
import { Absolute, Box } from '@rsos/components/capstone/base';

const CHAT_HEADER_HEIGHT = 60;

export const StatusCircle = styled(Absolute)`
  right: -2px;
  top: -2px;
  width: 11px;
  height: 11px;
  background-color: ${({ theme }) => theme.colors.lightDanger};
  border-radius: 50%;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Container = styled(Box).attrs({
  position: 'relative',
  horizontal: false,
  width: '100%',
  minHeight: CHAT_HEADER_HEIGHT,
  padding: '15px 12px',
  backgroundColor: 'background',
})`
  border-bottom: ${({ isChatBoxVisible, theme }) =>
    !isChatBoxVisible ? '0' : `1px solid ${theme.colors.lightLineDivider}`};
  border-radius: ${({ isChatBoxVisible }) =>
    isChatBoxVisible ? '5px 5px 0 0' : '5px'};
  &:before {
    ${({ isUnread }) => isUnread && unreadBar};
  }
`;

export const ContainerSection = styled(Box).attrs({
  horizontal: true,
  position: 'relative',
  align: 'center',
  width: '100%',
  backgroundColor: 'background',
})``;
